export const environment = {
    production: false,
    // baseUrl: 'https://api-dev-austinvicas.livnsense.com/',
    baseUrl: 'https://api-austinvicas.livnsense.com/',
      // baseUrl: 'http://localhost:8081/'
  };


